import { Button } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { IconHelpCircle } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { FeedbackModal } from "@/Components/ui";
import { mutateAdminPublish, mutateAdminSendApproval } from "@/Services/studio-design-request";

export const ACTION_APPROVAL = 'approval';
export const ACTION_PUBLISH = 'publish';

/**
 * AD-222: "Send Design Approval?" (the customer gets the design-ready email to
 * approve it) and "Publish Ad Without User Confirmation" (auto-approve: the design
 * is approved and the customer is asked to set up delivery and targeting).
 */
export const DesignActionModal = ({ request, action, onClose, onSuccess }) => {

    const { t } = useTranslation();
    const sendApproval = mutateAdminSendApproval();
    const publish = mutateAdminPublish();
    const mutation = action === ACTION_PUBLISH ? publish : sendApproval;
    const key = action === ACTION_PUBLISH ? 'publishModal' : 'approvalModal';

    const confirm = () => mutation.mutate(request.id, {
        onSuccess: () => {
            notifications.show({
                color: 'green',
                message: t(action === ACTION_PUBLISH ? 'designRequests.published' : 'designRequests.sentForApproval', {
                    campaign: request.campaign_name || request.advertiser_name,
                }),
            });
            onClose();
            onSuccess?.();
        },
        onError: (error) => notifications.show({
            color: 'red',
            message: error?.response?.data?.message || t('designRequests.actionFailed'),
        }),
    });

    return (
        <FeedbackModal
            opened={Boolean(request && action)}
            onClose={onClose}
            tone="pink"
            paddingX={24}
            icon={<IconHelpCircle size={32} stroke={1.6} />}
            title={t(`designRequests.${key}.title`)}
            actions={(
                <>
                    <Button variant="default" radius={8} fw={500} w={140} onClick={onClose}>{t('common.cancel')}</Button>
                    <Button color="pink.7" radius={8} fw={500} w={140} loading={mutation.isPending} onClick={confirm}>
                        {t(`designRequests.${key}.confirm`)}
                    </Button>
                </>
            )}
        >
            {t(`designRequests.${key}.text`)}
        </FeedbackModal>
    );
};
